import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PickImage, UploadImage } from '../../components/common/Camera';
import { InstallationAction, ErrorCodeAction, ProductAction } from '../../actions';
import { FileAddList } from '../../components/common/FileAddList';
import { FileUpload, FileItem } from '../../components/common/FileUpload';
import axios from 'axios';
import { AppConfig, JWT } from '../../config';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const InstallationStep2 = ({ info, Update, isSummary = false, Attachment, gostep }) => {
	// const [ t, i18n ] = useTranslation();
	const [installation, setInstallation] = useState(info);
	const [url, setUrl] = useState("");
	// BUG-236: 첨부가 없는 설치건은 attachments 가 undefined 라 filter/map 에서 크래시(흰 화면)
	const attachments = installation?.attachments ?? [];

	useEffect(() => {
		setInstallation(info);
	}, [info]);

	const Prev = () => {
		Update(installation._id, {
			...installation,
			installationStep: 2
		});
	};

	const validNext = (targetStep = 4) => {
		Update(installation._id, {
			...installation,
			installationStep: targetStep
		});
	};

	// 상단 배지·◀▶ 이동: 이 단계는 검증이 없고 첨부는 올리는 즉시 저장되므로 목표 단계만 저장한다.
	useEffect(() => {
		if (gostep && gostep.curStep == 3) {
			validNext(gostep.goStepNo);
		}
	}, [gostep]);

	const setNewFile = (file, fileType) => {
		Attachment(installation._id, "ADD", {
			...installation,
			name: file.original,
			path: file.s3path,
			attachmentType: fileType
		});
	};

	const delFile = (c) => {
		Attachment(installation._id, "DEL", {
			...installation,
			delAttachid: c._id
		});
	};

	const getImageFileAttachs = async (item) => {
		const ext = [".JPG", ".PNG", ".JPEG"];
		const ret = await axios.post(AppConfig.API_SERVER_PATH + "/file/geturl", {
			path: item,
			ctype: "image/" + item.slice((item.lastIndexOf(".") - 1 >>> 0) + 2)
		}, JWT());
		if (ret.data.status == "success") {
			setUrl(ret.data.data);
		}
	}

	return (
		<>
			<div className={isSummary ? "pb-2" : "section"}>
				{!isSummary && <div className="section-title">{t('installation.label.packagingCheck')}</div>}
				<div className={isSummary ? "" : "card mb-2"}>
					<div className={isSummary ? "section-title bdB2" : "card-header"}>{t('installation.label.shockIndicator')}</div>					
					{attachments.filter(item => 'shock' == item.type).length > 0 &&
						<ul className="list-group">
							{attachments.map((c, idx) =>
								c.type == "shock" &&
								<li className="list-group-item">
									<FileItem fileInfo={{ ...c, original: c.name, s3path: c.path }} callback={(c) => delFile(c)} key={idx} />
								</li>
							)}
						</ul>
					}
					{attachments.filter(item => 'shock' == item.type).length === 0 && <i className="p-2">Not exist.</i>}
					{!isSummary &&
						<div className="card-footer">
							<FileUpload
								option={{ doneandnew: true, label: t('common.button.upload') }}
								extraData={{ path: "installation/" + installation._id + "/" }}
								callback={(e) => setNewFile(e, 'shock')} />
						</div>}
				</div>
				<div className={isSummary ? "" : "card mb-2"}>
					<div className={isSummary ? "section-title bdB2" : "card-header"}>{t('installation.label.tiltWatch')}</div>
					{attachments.filter(item => 'tilt' == item.type).length > 0 &&
						<ul className="list-group">
							{attachments.map((c, idx) =>
								c.type == "tilt" &&
								<li className="list-group-item">
									<FileItem fileInfo={{ ...c, original: c.name, s3path: c.path }} callback={(c) => delFile(c)} key={idx} />
								</li>
							)}
						</ul>
					}
					{attachments.filter(item => 'tilt' == item.type).length === 0 && <i className="p-2">Not exist.</i>}
					{!isSummary &&
						<div className="card-footer">
							<FileUpload
								option={{ doneandnew: true, label: t('common.button.upload') }}
								extraData={{ path: "installation/" + installation._id + "/" }}
								callback={(e) => setNewFile(e, 'tilt')} />
						</div>}
				</div>
			</div>
			{!isSummary && <div className="section mt-1 mb-2">
				<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.next')}</button>
				<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
			</div>}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
	Attachment: (_id, type, data) => dispatch(InstallationAction.Attachment(_id, type, data)),
});

export default connect(null, mapDispatch)(InstallationStep2);